/**
 * @ngInject
 */

function intro() {

    return {
        addClass : function (elem, className, done) {
            console.log("addClass");
        },
        removeClass : function (elem, className, done) {
            console.log("removeClass");
            if (className === 'ng-hide'){
                
                console.log("remove ng-hide");
                // Animation here
            }
        },
        enter : function (elem, done) {
            console.log("done done done");
        },
        leave : function (elem, done) {
            console.log("leave");
        }
    };
}